import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { KeycloakService } from '../services/keycloak.service';
import { PHONE, MAIL } from '../utils/env';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  standalone: true,
  selector: 'sidebar-cmp',
  templateUrl: 'sidebar.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, FormsModule, TranslatePipe],
})
export class SidebarComponent {
  isActive = false;
  phone = PHONE;
  mail = MAIL;

  showMenu: string = '';
  showUsers: boolean;
  showFarms: boolean;
  showOrganisations: boolean;
  showParcels: boolean;
  showCampaigns: boolean;
  showPlanning: boolean;
  showOrders: boolean;
  showResults: boolean;

  constructor() {
    const roles: string[] = KeycloakService.auth.authz.tokenParsed.realm_access.roles;
    this.showCampaigns = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.showPlanning = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.showOrganisations =
      KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN') ||
      KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR') ||
      KeycloakService.auth.authz.hasRealmRole('ROLE_NEGOCE');
    // tous sauf ceux qui sont juste agriculteurs
    const setRoles: Set<string> = new Set<string>(roles);
    this.showUsers = !(roles.length === 1 && roles[0] === 'ROLE_FARMER');

    this.showFarms = true;
    this.showParcels = true;
    this.showOrders = true;
    this.showResults = true;
  }

  eventCalled() {
    this.isActive = !this.isActive;
  }
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
}
